<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    v-bind="$attrs"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L2 22H22L12 2Z"
      stroke-width="1.5"
      fill="none"
    />
    <path
      d="M12 8V14"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <circle
      cx="12"
      cy="18"
      r="1"
      fill="currentColor"
    />
  </svg>
</template>
